/**
 * Created : vincent
 * Date : 2017/4/26  下午2:19
 * Email : wangxiao@wafersystems.com
 */
import React from 'react';
import {Icon, Input, Modal} from 'antd';
import _ from 'lodash';

class RegionalMaintenanceTreeOperation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInput: props.node.openInput,
      title: props.title
    };
    this.inputHandle = this.inputHandle.bind(this);
    this.editHandle = this.editHandle.bind(this);
  }

  inputHandle(e) {
    const { node, editHandle } = this.props;
    editHandle(node, e.target.value);
    this.setState({ title: e.target.value });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.save && !nextProps.save) {
      this.setState({
        showInput: false
      });
    }
    if (nextProps.titleState === 1) {
      this.setState({ title: this.props.title });
    }
    // if(!nextProps.save){
    //   const {node} = this.props
    //   this.props.editHandle(node, this.state.title)
    // }
  }

  componentDidMount() {
    if (this.props.node.openInput) {
      this._a.focus();
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.title !== this.props.title) {
      this.setState({ showInput: false });
    }
  }

  editHandle() {
    const { intl, node, dispatch, cancelEditHandle, editHandle } = this.props;
    dispatch({
      type: 'account/changeTitleState',
      titleState: { titleState: 0 }
    });
    const this_ = this;
    if (this.state.showInput) {
      Modal.confirm({
        // title: '提示',
        content: intl.formatMessage({id:'department_maintenance_edit_tip'}),
        onOk() {
          cancelEditHandle(node);
          this_.setState({ showInput: false });
          if (_.isString(node.id)) {
            dispatch({ type: 'account/deleteAreaNodeAction', node: node });
          }
        },
        onCancel() {}
      });
    } else {
      editHandle(node, this.state.title);
      this.setState({ showInput: true });
    }
  }

  render() {
    const {
      title,
      node,
      addHandle,
      editHandle,
      delHandle,
      intl,
      save
    } = this.props;
    const showInput = this.state.showInput;
    return (
      <div className="regional_maintenance_tree_operation">
        {!showInput && <span>{title}</span>}
        {((showInput && save) || node.openInput) && (
          <Input
            className="input-color"
            type="text"
            placeholder={intl.formatMessage({
              id: 'regional_maintenance_edit_tip_placeholder'
            })}
            value={this.state.title}
            onChange={this.inputHandle}
            onClick={e => e.stopPropagation()}
            ref={a => (this._a = a)}
          />
        )}
        <div className="icon-list">
          {addHandle &&
            !node.openInput &&
            !showInput && (
              <div
                className="iconfont"
                onClick={e => {
                  e.stopPropagation();
                  addHandle(node);
                }}
              >
                <Icon type="plus" />
              </div>
            )}
          {!showInput &&
            editHandle && (
              <div
                className="iconfont icon-iconfontpencil"
                onClick={e => {
                  e.stopPropagation();
                  this.editHandle();
                }}
              />
            )}
          {showInput && (
            <div
              className="iconfont icon-x"
              onClick={e => {
                e.stopPropagation();
                this.editHandle();
              }}
            />
          )}
          {delHandle &&
            !node.openInput &&
            !showInput && (
              <div
                className="iconfont icon-lajitong"
                onClick={e => {
                  e.stopPropagation();
                  delHandle(node);
                }}
              />
            )}
        </div>
      </div>
    );
  }
}

export default RegionalMaintenanceTreeOperation;



// WEBPACK FOOTER //
// ./src/components/account/RegionalMaintenanceTreeOperation.js